export interface TooltipRowProps {
  label: string;
  value?: string;
  status?: 'warn' | 'error';
}

const TooltipRow = ({ label, value, status }: TooltipRowProps) => (
  <div className="tooling-tooltip__row">
    <span className="tooling-tooltip__row-label">
      {label} {status ? `${status === 'warn' ? '⚠️' : status === 'error' ? '🚨' : ' '}` : ''}
    </span>
    {value !== undefined && <span className="tooling-tooltip__row-value">{value}</span>}
  </div>
);

TooltipRow.displayName = 'ToolingCoverageTooltip.Row';

export default TooltipRow;
